import React from "react";
import "./headerSettings.scss";

import { Button, Stack } from "react-bootstrap";
import PersonIcon from "@mui/icons-material/Person";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { useScreenSize } from "../../../../ScreenSizeContext";
import ClickableImageWithModal from "../../../../components/clickableImageWithModal/ClickableImageWithModal";

const HeaderSettings = ({ image_type, image_profile, name, surname }) => {
  const isPC = useScreenSize();
  const navigate = useNavigate();

  return (
    <Stack gap={3} className="header-settings">
      {image_profile ? (
        <ClickableImageWithModal
          src={"data:" + image_type + ";base64," + image_profile}
          alt="Immagine profilo"
          style={{
            height: 120,
            width: 120,
            objectFit: "cover",
            borderRadius: "50%",
            border: "3px solid #03626e",
          }}
        />
      ) : (
        <PersonIcon className="image-profile" />
      )}
      <span className="name-surname">
        {name?.toUpperCase()} {surname?.toUpperCase()}
      </span>
      <Button
        style={{ borderRadius: 10 }}
        variant={"success"}
        onClick={() => {
          navigate("edit-user");
        }}
      >
        {t("settings.edit_profile")}
      </Button>
    </Stack>
  );
};

export default HeaderSettings;
